import React, { Fragment, useEffect, useRef, useState } from 'react'
import { useParams } from 'react-router-dom'
import { useNavigate, useLocation } from 'react-router-dom'
import {
    MDBAnimation,
    MDBContainer,
    MDBRow,
    MDBCol,
    MDBInput,
    MDBTextArea,
    MDBSelect,
    MDBCheckbox,
    MDBRadio,
    MDBFile,
    MDBBtn,
    MDBModal,
    MDBModalDialog,
    MDBModalContent,
    MDBModalHeader,
    MDBModalTitle,
    MDBModalBody,
    MDBModalFooter,
} from 'mdb-react-ui-kit'
import { MDBTreeTable, MDBTreeTableItem, MDBTreeTableHead, MDBTreeTableBody } from 'mdb-react-treetable';

import stateService from '../../services/states'
import slotService from '../../services/slots'
import cityService from '../../services/cities'
import versionCityService from '../../services/versionCities'
import versionInstitutionService from '../../services/versionInstitutions'
import activityTypeService from '../../services/activityTypes'
import activityService from '../../services/activities'
import institutionService from '../../services/institutions'
import SiteHeader from '../../components/SiteHeader'
import Breadcrumbs from '../../components/Breadcrumbs'
export default function SelfEvaluation() {
    const navigateTo = useNavigate();
    const [selectedProfile, setSelectedProfile] = useState(null);
    const [loadedData, setLoadedData] = useState(false);
    const { id } = useParams()


    const breadCrumbsData = [
        {
            text: 'Inicio',
            href: `/home`
        },
        {
            text: 'Versiones',
            href: `/versions`
        },
        {
            text: `Autodiagnósticos`,
        },
    ];

    const handleDataLoad = async () => {
        const activityTypes = await activityTypeService.listByVersion(id)
        const activities = await activityService.listByVersion(id)
        const institutions = await institutionService.list()
        const states = await stateService.list()
        const slots = await slotService.listByVersion(id)
        const cities = await cityService.list()
        const versionCities = await versionCityService.listByVersion(id)
        const versionInstitutions = await versionInstitutionService.listByVersion(id)

        let activityTypeSelfEvaluation = activityTypes.filter(activityType => activityType.activityTypeName === 'Autodiagnóstico')[0]

        let newLoadedData;

        newLoadedData = states.map(state => {
            return {
                ...state,
                slots: slots.filter(
                    slot => slot.state_id === state.id
                )[0],
                usedSlots: 0,
                cities: cities.filter(
                    city => city.state_id === state.id
                ).map(
                    city => {
                        return {
                            ...city,
                            versionCities: versionCities.filter(
                                versionCity => versionCity.city_id === city.id
                            ),
                            institutions: institutions.filter(
                                institution => institution.city_id === city.id
                            ).map(
                                institution => {
                                    let versionInstitutionExist = versionInstitutions.filter(
                                        versionInstitution => versionInstitution.institution_id === institution.id
                                    ).length > 0;
                                    let versionInstitutionStatus = null;
                                    if (versionInstitutionExist) {
                                        versionInstitutionStatus = versionInstitutions.filter(
                                            versionInstitution => versionInstitution.institution_id === institution.id
                                        )[0].versionInstitutionStatus
                                    }
                                    return {
                                        ...institution,
                                        activities: activities
                                            .filter(
                                                activity => activity.institution_id === institution.id
                                            )
                                            .filter(
                                                activity => activity.activityStatus === 'finalizada'
                                            )
                                            .filter(
                                                activity => activity.activityType_id === activityTypeSelfEvaluation.id
                                            ),
                                        selfEvaluationScore: activities
                                            .filter(
                                                activity => activity.institution_id === institution.id
                                            )
                                            .filter(
                                                activity => activity.activityStatus === 'finalizada'
                                            )
                                            .filter(
                                                activity => activity.activityType_id === activityTypeSelfEvaluation.id
                                            )[0]?.activityTotalScore || 0,
                                        versionInstitutionExist: versionInstitutionExist,
                                        versionInstitutionStatus: versionInstitutionStatus
                                    }
                                }
                            ).filter(
                                institution => institution.activities.length > 0
                            ).sort(
                                (a, b) => b.selfEvaluationScore - a.selfEvaluationScore
                            )
                        }
                    }
                )
            }
        }).map(state => {
            //check all institutions in state that are in version
            let usedSlots = 0;
            state.cities.forEach(city => {
                city.institutions.forEach(institution => {
                    if (institution.versionInstitutionExist) {
                        usedSlots += 1;
                    }
                })
            })

            

            return {
                ...state,
                usedSlots: usedSlots
            }
        })

        setLoadedData(newLoadedData)

        //console.log(newLoadedData)

    }

    const handleRemoveFromVersion = async (institutionId) => {
        const versionInstitution = await versionInstitutionService
            .listByVersion(id)

        const filtered = versionInstitution.filter(versionInstitution => versionInstitution.institution_id === institutionId)

        if (filtered.length > 0) {
            await versionInstitutionService.remove(filtered[0].id)
            handleDataLoad()
        }

    }

    const handleAddToVersion = async (institutionId) => {
        const versionInstitution = await versionInstitutionService
            .listByVersion(id)

        const filtered = versionInstitution.filter(versionInstitution => versionInstitution.institution_id === institutionId)

        if (filtered.length == 0) {
            await versionInstitutionService.create({
                version_id: id,
                institution_id: institutionId
            })
            handleDataLoad()
        }
    }

    useEffect(() => {
        handleDataLoad()
    }, [])

    return (
        <>
            <SiteHeader
                selectedProfile={selectedProfile}
            />
            <MDBAnimation
                animation='fade-in'
                start='onLoad'
                duration={700}
            >
                <MDBRow className='my-4 ms-4'>
                    <Breadcrumbs
                        items={breadCrumbsData}
                    />
                </MDBRow>
                <MDBContainer>
                    {
                        loadedData &&
                        <MDBTreeTable>
                            <MDBTreeTableHead heads={['Nombre', 'Valor', '']} />
                            <MDBTreeTableBody>
                                {
                                    loadedData
                                        .filter(
                                            state => state.cities.filter(
                                                city => city.institutions.filter(
                                                    institution => institution.activities.filter(
                                                        activity => activity.activityStatus === 'finalizada'
                                                    ).length > 0
                                                ).length > 0
                                            ).length > 0
                                        )
                                        .map(state => {
                                            return <Fragment key={state.id}>
                                                <MDBTreeTableItem
                                                    className={
                                                        state.slots?.slotQuantity > 0 ? 'text-success' : 'text-danger'
                                                    }
                                                    depth={1}
                                                    values={
                                                        [
                                                            'Región: ' + state.stateName,
                                                            'Comunas: '
                                                            + state.cities
                                                                .filter(
                                                                    city => city.institutions
                                                                        .filter(
                                                                            institution => {
                                                                                return institution
                                                                                    .activities
                                                                                    .filter(activity => activity.activityStatus === 'finalizada')
                                                                            }
                                                                        )
                                                                        .length > 0)
                                                                .length,
                                                            `Cupos ocupados: ${state.usedSlots} de ${state.slots?.slotQuantity || 0}`,
                                                        ]
                                                    }
                                                />
                                                {
                                                    state.cities
                                                        .filter(
                                                            city => city.institutions.filter(
                                                                institution => institution.activities.filter(
                                                                    activity => activity.activityStatus === 'finalizada'
                                                                ).length > 0
                                                            ).length > 0
                                                        )
                                                        .map(city => {
                                                            return <Fragment key={city.id}>
                                                                <MDBTreeTableItem
                                                                    className={
                                                                        state.slots?.slotQuantity > 0 ?
                                                                            city.versionCities[0]?.versionCityStatus === 'activa' ? 'text-success' : 'text-danger'
                                                                            : 'text-danger'
                                                                    }
                                                                    depth={2}
                                                                    values={
                                                                        [
                                                                            'Comuna: ' + city.cityName,
                                                                            'Establecimientos: ' + city.institutions.length,
                                                                            'Estado comuna: ' + (city.versionCities[0]?.versionCityStatus).toUpperCase(),
                                                                        ]
                                                                    }
                                                                />
                                                                {
                                                                    city.institutions
                                                                        .filter(
                                                                            institution => institution.activities.filter(
                                                                                activity => activity.activityStatus === 'finalizada'
                                                                            ).length > 0
                                                                        )
                                                                        .map(
                                                                            institution => {
                                                                                return <Fragment key={institution.id}>
                                                                                    <MDBTreeTableItem
                                                                                        depth={3}
                                                                                        values={
                                                                                            [
                                                                                                'Institución: ' + institution.institutionName + ' (' + institution.institutionRBD + ')',
                                                                                                'Puntaje: ' + institution.activities[0].activityTotalScore,
                                                                                                <>
                                                                                                    <MDBBtn
                                                                                                        color='success'
                                                                                                        onClick={() => {
                                                                                                            navigateTo(`/check/self-evaluation/${institution.activities[0].id}`, {
                                                                                                                state: {
                                                                                                                    origin: '/tree/self-evaluation',
                                                                                                                    version: id,
                                                                                                                }
                                                                                                            })
                                                                                                        }}
                                                                                                    >
                                                                                                        Ver
                                                                                                    </MDBBtn>
                                                                                                    {
                                                                                                        institution.versionInstitutionExist ?
                                                                                                            institution.versionInstitutionStatus === 'en espera' &&
                                                                                                            <MDBBtn
                                                                                                                color='danger ms-2'
                                                                                                                outline
                                                                                                                onClick={() => {
                                                                                                                    handleRemoveFromVersion(institution.id)
                                                                                                                }}
                                                                                                            >
                                                                                                                Quitar
                                                                                                            </MDBBtn>
                                                                                                            :
                                                                                                            <>
                                                                                                                {
                                                                                                                    state.slots?.slotQuantity > 0
                                                                                                                    && state.usedSlots < state.slots?.slotQuantity
                                                                                                                    && city.versionCities[0]?.versionCityStatus !== 'activa'
                                                                                                                    &&
                                                                                                                    <MDBBtn
                                                                                                                        color='danger ms-2'
                                                                                                                        onClick={() => {
                                                                                                                            handleAddToVersion(institution.id)
                                                                                                                        }}
                                                                                                                    >
                                                                                                                        Escoger
                                                                                                                    </MDBBtn>
                                                                                                                }
                                                                                                                {
                                                                                                                    state.slots?.slotQuantity > 0
                                                                                                                    && state.usedSlots < state.slots?.slotQuantity
                                                                                                                    && city.versionCities[0]?.versionCityStatus === 'activa'
                                                                                                                    &&
                                                                                                                    <MDBBtn
                                                                                                                        color='primary ms-2'
                                                                                                                        onClick={() => {
                                                                                                                            handleAddToVersion(institution.id)
                                                                                                                        }}
                                                                                                                    >
                                                                                                                        Escoger
                                                                                                                    </MDBBtn>
                                                                                                                }
                                                                                                            </>
                                                                                                    }
                                                                                                </>
                                                                                            ]
                                                                                        }
                                                                                    />
                                                                                </Fragment>
                                                                            }
                                                                        )
                                                                }
                                                            </Fragment>
                                                        })
                                                }
                                            </Fragment>
                                        })
                                }
                            </MDBTreeTableBody>
                        </MDBTreeTable>
                    }
                </MDBContainer>
            </MDBAnimation>
        </>
    )
}
